module.exports = __webpack_public_path__ + "static/media/迷你鍋.a5595e6e.jpg";